// import _ from 'lodash'
export default {
  // Load language form multilingual API
  setCurrentScreen (context, currentScreen) {
    context.commit('SET_CURRENT_SCREEN', currentScreen)
  },
  setCardSuffer (context, isSuffer) {
    context.commit('SET_CARD_SUFFER', isSuffer)
  },
  setPcDiceStatus (context, isSake) {
    context.commit('SET_PC_DICE_STATUS', isSake)
  },
  setHorseColor (context, colorHorse) {
    context.commit('SET_HOUSE_COLOR', colorHorse)
  },
  setResult (context, isWin) {
    context.commit('SET_RESULT', isWin)
  },
  setSoundMute (context, soundMute) {
    context.commit('SET_SOUND_MUTE', soundMute)
  },
  setHorseStatus (context) {
    context.getters.get2Horse()
  },
  setBtnClick (context) {
    context.getters.buttonDiceClick()
  },
  setDice (context, { currentDice, diceData }) {
    context.commit('SET_DICE_DATA', {
      'currentDice': currentDice,
      'diceData': diceData
    })
  },
  setSpecialCard (context, dna) {
    context.getters.specialCard(dna)
  },
  setStopSufferCard (context, isStop) {
    context.commit('SET_STOP_SUFFER_CARD', isStop)
  },
  setHorseRun (context, {currentHorse, raceStatus}) {
    context.commit('SET_HORSE_RUN', {
      'currentHorse': currentHorse,
      'raceStatus': raceStatus
    })
  },
  setDiceRun (context, {currentDice, diceStatus}) {
    context.commit('SET_DICE_RUN', {
      'currentDice': currentDice,
      'diceStatus': diceStatus
    })
  },
  showRaceTextStart (context, isShow) {
    context.commit('SHOW_RACE_TEXT_START', isShow)
  },
  showRaceTextGoal (context, isShow) {
    context.commit('SHOW_RACE_TEXT_GOAL', isShow)
  },
  setReplay (context, isReplay) {
    context.commit('SET_REPLAY', isReplay)
  },
  setSpecialToCard (context, cardID) {
    context.commit('SET_SPECIAL_TO_CARD', cardID)
  },
  resetGame (context) {
    context.commit('RESET_GAME')
  },
  setResetStatus (context, isReset) {
    context.commit('SET_RESET_STATUS', isReset)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js